import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export const containsOperator = {
  label: i18n('card.actions.filters.fields.common.operator.contains'),
  id: 'contains',
};

export const emptyOperator = {
  label: i18n('card.actions.filters.fields.date.operator.empty'),
  id: 'empty',
};

export const doesNotContainOperator = {
  label: i18n('card.actions.filters.fields.common.operator.doesNotContain'),
  id: 'does-not-contain',
};

export const basicOperators = [emptyOperator, containsOperator];

export function BasicOperatorItem({ text }) {
  const colors = useContext(ColorThemeContext);
  return (
    <View padding={1}>
      <MBTextBody1 color={colors.foregroundActive}>{text}</MBTextBody1>
    </View>
  );
}
